import React, { useState, useEffect } from "react";
import myHeaderVideo from "./nrdruhsheader.mp4";
import "./Home.css";
import bookArticleImg from "./NRDRUHSArticle.png"; // Import the logo image
import ManuScriptSlider from "./ManuScriptSlider";
import NRDRUHSFooter from "./NRDRUHSFooter";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Home() {
  const team = [
    {
      name: "Dr. Manoj Aggarwal",
      designation: "Additional Principal, & Hon. Advisory Board Member",
      department: "National Research Denticon",
      image: "https://nrdruhs.in/uploads/DrManojAgarwal.jpg",
    },
    {
      name: "Dr. Bharat Sankhala",
      designation: "Chief Editor",
      department: "National Research Denticon",
      image: "https://nrdruhs.in/uploads/BharatSankhala.jpg",
    },
  ];

  const team2 = [
    {
      name: "Dr. Lalit Likhyani",
      designation: "Joint Secretary",
      department: "National Research Denticon",
      image: "https://nrdruhs.in/uploads/DrLalitLIkhlani.jpg",
    },
    {
      name: "Dr. Krishna Sireesha S",
      designation: "Treasurer & Joint Secretary",
      department: "National Research Denticon",
      image: "https://nrdruhs.in/uploads/KrishnaSireeshaSundaragiri.jpg",
    },
    {
      name: "Dr. Neha Gupta",
      designation: "Joint Secretary",
      department: "National Research Denticon",
      image: "https://nrdruhs.in/uploads/drnehaguptaimg.jpg",
    },
  ];

  const navigate = useNavigate();

  const handleSubmitClick = () => {
    const isLoggedIn = localStorage.getItem("userToken"); // or whatever key you use
    if (isLoggedIn) {
      navigate("/manuscriptsteps");
    } else {
      navigate("/login"); // redirect to login page
    }
  };

  const [scrolling, setScrolling] = useState(false);
  const [showVcMessage, setShowVcMessage] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 0) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  // Function to handle the click event of the "Scroll to Top" button
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    // Attach the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Header Banner */}
      <div className="header-container">
        <video autoPlay muted loop className="fullscreen-video">
          <source src={myHeaderVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay"></div> {/* Overlay added here */}
        <div className="video-title">
          <span style={{ fontSize: 12 }}></span>
          <span className="outline-text small-font">
            WELCOME TO
            <br />
          </span>
          <span style={{ fontSize: 30 }}></span>
          <span className="outline-text larger-font">
            NATIONAL RESEARCH DENTICON
          </span>
        </div>
        <p
          className="video-subtitle"
          style={{
            fontSize: 15,
            paddingTop: 3,
            fontWeight: 300,
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
            color: "white",
            background: "red",
            paddingLeft: 3,
            paddingRight: 3,
          }}
        >
          <strong>
            An Official Journal of Rajasthan University for Health Sciences
          </strong>
        </p>
      </div>

      <div
        className="row"
        style={{
          margin: 0,
          paddingBottom: 45,
          marginTop: -86,
          background: "linear-gradient(to right, #5433ff, #20bdff, #a5fecb)",
          overflowX: "hidden",
        }}
      >
        <div
          className="col-lg-8 col-md-12"
          data-aos="fade-up"
          data-aos-duration="1200"
          style={{ paddingLeft: 45, paddingRight: 45, textAlign: "justify" }}
        >
          <div
            className="card card-with-shadow"
            style={{
              background: "linear-gradient(to bottom, #0033ff, #003366)",
              padding: "45px",
              borderRadius: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "15px",
                paddingTop: 30,
                paddingBottom: 18,
              }}
            >
              <img
                src="https://nrdruhs.in/uploads/DrPramodYeole.jpg"
                alt="Prof. (Dr.) Pramod Yeole"
                style={{
                  width: "70px",
                  height: "70px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "2px solid white",
                  flexShrink: 0,
                }}
              />

              <h3
                style={{
                  fontSize: 27,
                  fontWeight: "bold",
                  color: "white",
                  margin: 0,
                }}
              >
                MESSAGE FROM THE VICE-CHANCELLOR
              </h3>
            </div>
            <p style={{ color: "white", lineHeight: 1.8, marginBottom: 24 }}>
              It gives me immense pleasure to extend my warm greetings and best
              wishes to the <strong>National Research Denticon</strong>, the
              official peer-reviewed journal of RUHS College of Dental Sciences,
              Jaipur under the academic and professional ecosystem of Rajasthan
              University of Health Sciences.
            </p>
            <button
              type="button"
              className="btn btn-light"
              onClick={() => setShowVcMessage(true)}
              style={{
                fontWeight: 600,
                color: "#003366",
                borderRadius: "50px",
                padding: "10px 24px",
                boxShadow: "0 3px 10px rgba(0,0,0,0.22)",
              }}
            >
              Read Full Message{" "}
              <i className="fas fa-arrow-right" style={{ marginLeft: 8 }}></i>
            </button>
          </div>
        </div>
        <div
          className="col-lg-4 col-md-12 main-image-container"
          data-aos="fade-right"
          data-aos-duration="1800"
          style={{
            paddingTop: 0,
            paddingLeft: 15,
            paddingRight: 15,
            textAlign: "center",
          }}
        >
          <div className="d-flex flex-column justify-content-center align-items-center h-100">
            <div
              className="mb-2"
              style={{ width: "100%", maxWidth: "340px", paddingBottom: 21 }}
            >
              <Link to="/nrddownloads" style={{ textDecoration: "none" }}>
                <button
                  type="button"
                  className="btn btn-success btn-lg btn-block"
                  style={{ width: "100%", padding: "1.5rem" }}
                >
                  <i
                    className="fas fa-cloud-download-alt"
                    style={{
                      paddingRight: 9,
                      fontSize: 30,
                      verticalAlign: "middle",
                    }}
                  />
                  Downloads
                </button>
              </Link>
            </div>

            <div
              className="mb-2"
              style={{ width: "100%", maxWidth: "340px", paddingBottom: 21 }}
            >
              <button
                type="button"
                className="btn btn-primary btn-lg btn-block"
                style={{ width: "100%", padding: "1.5rem" }}
                onClick={() =>
                  window.open("/uploads/authorguidelines.pdf", "_blank")
                }
              >
                <i
                  className="fas fa-file-pdf"
                  style={{
                    paddingRight: 9,
                    fontSize: 30,
                    verticalAlign: "middle",
                  }}
                />
                Author Guidelines
              </button>
            </div>

            <div
              className="mb-2"
              style={{ width: "100%", maxWidth: "340px", paddingBottom: 21 }}
            >
              <div
                className="mb-2"
                style={{ width: "100%", maxWidth: "340px", paddingBottom: 21 }}
              >
                <button
                  type="button"
                  className="btn btn-danger btn-lg btn-block"
                  style={{ width: "100%", padding: "1.5rem" }}
                  onClick={handleSubmitClick}
                >
                  <i
                    className="fas fa-cloud-upload-alt"
                    style={{
                      paddingRight: 9,
                      fontSize: 30,
                      verticalAlign: "middle",
                    }}
                  />
                  Submit Your Article
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row" style={{ margin: 0 }}>
        <div
          style={{
            margin: 0,
            background: "linear-gradient(to bottom, #003366, #0033ff)",
            paddingBottom: 60,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          {/* Heading */}
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingTop: 60,
            }}
          >
            <h3
              style={{
                fontSize: 30,
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.4)",
                color: "white",
                fontWeight: "bold",
                marginBottom: 10,
              }}
            >
              CURRENT ISSUE PUBLISHED
            </h3>
            <h4
              style={{
                marginTop: 15,
                marginBottom: 30,
                color: "white",
                fontSize: 18,
              }}
            >
              Current Issue - NRD RUHS Vol 14 Issue 4 (Oct-Dec 2025)
            </h4>
          </div>

          {/* Two Columns */}
          <div
            className="row"
            style={{ width: "100%", margin: 0, padding: "0 20px" }}
          >
            {/* Left Column */}
            <div
              className="col-sm-6"
              style={{ textAlign: "center", marginBottom: 30 }}
            >
              <img
                src="https://nrdruhs.in/uploads/NRDRHUSPublicationNewVol14No4.jpg"
                alt="Current Issue"
                style={{
                  width: "60%",
                  cursor: "pointer",
                  border: "1px solid lightgrey",
                  borderRadius: 4,
                }}
                onClick={() =>
                  window.open(
                    "https://nrdruhs.in/uploads/ARTICLES-MERGED-OCT-DEC-2025-VOL-14-ISSUE-4.pdf",
                    "_blank",
                  )
                }
              />
              <div style={{ marginTop: 15 }}>
                <a
                  href="https://nrdruhs.in/uploads/ARTICLES-MERGED-OCT-DEC-2025-VOL-14-ISSUE-4.pdf"
                  rel="noopener noreferrer"
                  download
                  style={{
                    width: 200,
                    display: "inline-block",
                    textDecoration: "none",
                    padding: "10px 20px",
                    borderRadius: 5,
                    backgroundColor: "#ffffff",
                    color: "#003366",
                    fontWeight: "bold",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    border: "none",
                  }}
                >
                  <i className="fa fa-download" style={{ marginRight: 10 }}></i>
                  Download PDF
                </a>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-sm-6" style={{ color: "white" }}>
              <h1
                style={{ fontSize: 18, marginBottom: 15, fontWeight: "bold" }}
              >
                INDIVIDUAL ARTICLES
              </h1>
              <ul style={{ paddingLeft: 10, margin: 0 }}>
                {[
                  {
                    title:
                      "Study on Prevalence of Oral Submucous Fibrosis among Nonsmokers’ Patients Visiting Dental College in Chandwaji, Jaipur - A Cross-Sectional Study",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrSunilKumarGurjar.pdf",
                    author: "Dr. Sunil Kumar Gurjar",
                  },
                  {
                    title:
                      "Knowledge, Attitude and Practice Among under Graduate Dental Students, Regarding Dental Lasers at NIMS Dental College Rajasthan: A Questionnaire Based Survey",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrKhushbuSoni.pdf",
                    author: "Dr. Khushbu Soni",
                  },
                  {
                    title:
                      "Management of Pediatric Mandibular Parasymphysis Fractures with Associated Subcondylar and Angle Injuries using Intermaxillary Fixation: Report of Two Distinct Cases",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrLipikaGuwalani.pdf",
                    author: "Dr. Lipika Guwalani",
                  },
                  {
                    title:
                      "To Compare the Efficacy of Gentamicin Coated Collagen Membrane with Collagen Membrane Plain in  Extraction Wounds after Surgical Removal of Impacted Mandibular 3rd Molars",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrRachanaSharma.pdf",
                    author: "Dr. Rachana Sharma",
                  },
                  {
                    title:
                      "Preserving Pulp Vitality: Full Pulpotomy with MTA Putty In Mature Permanent Teeth with Irreversible Pulpitis: A Case Series",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrAmbikaBhardwaj.pdf",
                    author: "Dr. Ambika Bhardwaj",
                  },
                  {
                    title:
                      "Management of Deciduous Lower Anterior Teeth in the Absence of their Permanent Successors - A Case Report",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrKritiShikha.pdf",
                    author: "Dr. Kriti Shikha",
                  },
                  {
                    title:
                      "Survival of Avulsed Permanent Incisors Following Prolonged Extraoral Time: A Case Report",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrDodiaKhyatiMayur.pdf",
                    author: "Dr. Dodia Khyati Mayur",
                  },

                  {
                    title:
                      "Comparative Evaluation of Sandblasting on Retention of Orthodontic Bands Using Different Dental Cements - An In Vitro Study",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrIshaniSheth.pdf",
                    author: "Dr. Ishani Sheth",
                  },

                  {
                    title:
                      "Comparative Evaluation of Nasolabial Flap and Buccal Fat Pad Graft in the Surgical Management of Oral Submucous Fibrosis: A Comparative Study",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/Dr.AnkushKumarAgrawal.pdf",
                    author: "Dr. Ankush Kumar Agrawal",
                  },

                  {
                    title:
                      "Assessment of Audio-Visual Advertisement and their Effects on Food Habits & Oral Health among Private School Children of Age 10-12 Years in Jaipur City: A Cross Sectional Study",
                    link: "https://nrdruhs.in/uploads/NRDRUHSVol14Issue4OctDec2025/DrMehulMer.pdf",
                    author: "Dr. Mehul Mer",
                  },
                ].map(({ title, link, author }, idx) => (
                  <li key={idx} style={{ marginBottom: 10 }}>
                    <a
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "white" }}
                    >
                      {title}
                    </a>
                    <div style={{ color: "#66ccff" }}>{author}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div
        className="row"
        style={{
          height: 560,
          margin: 0,
          backgroundImage:
            "url(https://nrdruhs.in/uploads/uttamkalakarbgnew.jpg)",
          backgroundSize: "cover",
        }}
      >
        <h3
          style={{
            fontSize: 30,
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.4)",
            textAlign: "center",
            paddingTop: 90,
            paddingBottom: 0,
            color: "white",
            fontWeight: "bold",
          }}
        >
          OUR PUBLISHED ARTICLES
        </h3>
        <ManuScriptSlider />
      </div>

      <div
        className="row"
        style={{
          background: "linear-gradient(to right, #5433ff, #20bdff, #a5fecb)",
          margin: 0,
          minHeight: "300px",
        }}
      >
        <div
          className="col-sm-6 col-md-3 d-flex justify-content-center align-items-center"
          style={{ textAlign: "center" }}
        ></div>

        <div
          className="col-sm-12 col-md-4 d-flex align-items-center"
          style={{ paddingLeft: 30 }}
        >
          <p style={{ color: "white", fontSize: "18px", paddingTop: 30 }}>
            <h3>
              <strong>SUBMIT YOUR ARTICLE</strong>
            </h3>
            Register with us to submit your Article!
          </p>
        </div>

        <div className="col-sm-6 col-md-4">
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              overflow: "hidden",
              marginBottom: "-100px",
            }}
          >
            <img
              src={bookArticleImg}
              alt="buynow"
              style={{
                maxHeight: "90%",
                maxWidth: "90%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>

      <div
        className="container-fluid py-5"
        style={{ background: "linear-gradient(to bottom, #fff, #999)" }}
      >
        <h2
          className="text-center mb-5"
          style={{ fontWeight: 600, color: "#003366" }}
        >
          EDITORIAL BOARD
        </h2>

        {/* Two Inline Cards Above the 3 Cards */}
        <div className="row justify-content-center mb-4">
          {/* Card 1 */}
          <div className="col-md-6 col-lg-5 d-flex flex-column align-items-center mb-3 mb-md-0">
            {/* Heading for First Card */}
            <h3
              className="text-center mb-3"
              style={{ fontWeight: 600, color: "#000" }}
            >
              Chief Patron
            </h3>

            {/* Card Content */}
            <div
              className="text-center shadow-lg"
              style={{
                background: "linear-gradient(to bottom, #ff2056, #003366)",
                padding: "60px",
                borderRadius: "10px",
                width: "100%",
                maxWidth: "350px",
                transition: "transform 0.3s ease",
                color: "#ffffff",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <img
                src="https://nrdruhs.in/uploads/DrPramodYeole.jpg"
                alt="Dr. Pramod Yeole"
                className="rounded-circle mb-3"
                style={{
                  width: "150px",
                  height: "150px",
                  objectFit: "cover",
                  border: "4px solid #ffffff",
                  marginBottom: "20px",
                }}
              />
              <h5
                className="card-title mt-2"
                style={{ fontWeight: "bold", color: "#ffffff" }}
              >
                Dr. Pramod Yeole
              </h5>
              <p className="text-light mb-1" style={{ fontSize: "0.95rem" }}>
                Hon'ble Vice Chancellor
              </p>
              <p
                className="text-light"
                style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
              >
                Rajasthan University of Health Sciences, Jaipur, Rajasthan
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 col-lg-5 d-flex flex-column align-items-center">
            {/* Heading for Second Card */}
            <h3
              className="text-center mb-3"
              style={{ fontWeight: 600, color: "#000" }}
            >
              Patron and Chairman
            </h3>

            {/* Card Content */}
            <div
              className="text-center shadow-lg"
              style={{
                background: "linear-gradient(to bottom, #003366, #ff2056)",
                padding: "60px",
                borderRadius: "10px",
                width: "100%",
                maxWidth: "350px",
                transition: "transform 0.3s ease",
                color: "#ffffff",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <img
                src="https://nrdruhs.in/uploads/DrSankalpMittal.jpg"
                alt="Dr. Anjali Kapoor"
                className="rounded-circle mb-3"
                style={{
                  width: "150px",
                  height: "150px",
                  objectFit: "cover",
                  border: "4px solid #ffffff",
                  marginBottom: "20px",
                }}
              />
              <h5
                className="card-title mt-2"
                style={{ fontWeight: "bold", color: "#ffffff" }}
              >
                Dr. Sankalp Mittal
              </h5>
              <p className="text-light mb-1" style={{ fontSize: "0.95rem" }}>
                Additional Principal
              </p>
              <p
                className="text-light"
                style={{ fontSize: "0.9rem", lineHeight: "1.4" }}
              >
                RUHSCDS, National Research Denticon Jaipur, Rajasthan
              </p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center" style={{ marginTop: 60 }}>
          <h2
            className="text-center mb-5"
            style={{ fontWeight: 600, color: "#003366" }}
          >
            Hon'ble Advisory Board Members
          </h2>

          {team2.map((member, index) => (
            <div
              className="col-md-4 d-flex justify-content-center mb-4"
              key={index}
            >
              <div
                className="text-center shadow-lg"
                style={{
                  background: "linear-gradient(to bottom, #ff2056, #003366)",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "300px",
                  transition: "transform 0.3s ease",
                  color: "#ffffff",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="rounded-circle mb-3"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    border: "4px solid #ffffff",
                    marginBottom: "20px",
                  }}
                />
                <h5
                  className="card-title mt-2"
                  style={{ fontWeight: "bold", color: "#ffffff" }}
                >
                  {member.name}
                </h5>
                <p className="text-light mb-1" style={{ fontSize: "0.95rem" }}>
                  {member.designation}
                </p>
                <p className="text-light" style={{ fontSize: "0.9rem" }}>
                  {member.department}
                </p>
              </div>
            </div>
          ))}

          {team.map((member, index) => (
            <div
              className="col-md-4 d-flex justify-content-center mb-4"
              key={index}
              style={{ marginTop: 60 }}
            >
              <div
                className="text-center shadow-lg"
                style={{
                  background: "linear-gradient(to bottom, #ff2056, #003366)",
                  padding: "30px",
                  borderRadius: "10px",
                  width: "100%",
                  maxWidth: "300px",
                  transition: "transform 0.3s ease",
                  color: "#ffffff",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="rounded-circle mb-3"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    border: "4px solid #ffffff",
                    marginBottom: "20px",
                  }}
                />
                <h5
                  className="card-title mt-2"
                  style={{ fontWeight: "bold", color: "#ffffff" }}
                >
                  {member.name}
                </h5>
                <p className="text-light mb-1" style={{ fontSize: "0.95rem" }}>
                  {member.designation}
                </p>
                <p className="text-light" style={{ fontSize: "0.9rem" }}>
                  {member.department}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4 mb-5" style={{ marginTop: 60 }}>
          <Link
            to="/advisoryboard"
            className="btn btn-lg shadow"
            style={{
              background: "linear-gradient(to right, #003366, #ff2056)",
              color: "#ffffff",
              fontWeight: "600",
              padding: "12px 40px",
              border: "none",
              borderRadius: "50px",
              textDecoration: "none",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              display: "inline-block",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 6px 15px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            Advisory Board
          </Link>
        </div>
      </div>

      {/* Vice-Chancellor Full Message Modal */}
      {showVcMessage && (
        <div
          onClick={() => setShowVcMessage(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.72)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "900px",
              maxHeight: "88vh",
              overflowY: "auto",
              background: "#ffffff",
              borderRadius: "14px",
              padding: "42px 42px 35px",
              boxShadow: "0 15px 45px rgba(0,0,0,0.35)",
              color: "#222222",
            }}
          >
            {/* Close X Button */}
            <button
              type="button"
              aria-label="Close Vice-Chancellor message"
              onClick={() => setShowVcMessage(false)}
              style={{
                position: "absolute",
                top: 14,
                right: 16,
                width: 38,
                height: 38,
                borderRadius: "50%",
                border: "none",
                background: "#003366",
                color: "#ffffff",
                fontSize: 24,
                lineHeight: "38px",
                cursor: "pointer",
              }}
            >
              &times;
            </button>

            {/* Vice-Chancellor Image + Heading */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "18px",
                marginBottom: 28,
                paddingRight: 40,
              }}
            >
              <img
                src="https://nrdruhs.in/uploads/DrPramodYeole.jpg?v=2"
                alt="Prof. (Dr.) Pramod Yeole"
                style={{
                  width: "75px",
                  height: "75px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  border: "2px solid #003366",
                  flexShrink: 0,
                }}
              />

              <h2
                style={{
                  color: "#003366",
                  fontWeight: "bold",
                  fontSize: 28,
                  margin: 0,
                }}
              >
                MESSAGE FROM THE VICE-CHANCELLOR
              </h2>
            </div>

            {/* Full Message */}
            <div
              style={{
                fontSize: 16,
                lineHeight: 1.5,
                textAlign: "justify",
              }}
            >
              <p>
                It gives me immense pleasure to extend my warm greetings and
                best wishes to the <strong>National Research Denticon</strong>,
                the official peer-reviewed journal of RUHS College of Dental
                Sciences, Jaipur under the academic and professional ecosystem
                of Rajasthan University of Health Sciences.
              </p>

              <p>
                The journal has established an important platform for the
                dissemination of high-quality research and scholarly work in
                dentistry, oral and maxillofacial health, head and neck
                sciences, and related areas. Its comprehensive scope,
                encompassing clinical, experimental, diagnostic, and public
                health research across various dental specialties, reflects the
                multidisciplinary and rapidly advancing nature of contemporary
                dental sciences.
              </p>

              <p>
                I am confident that National Research Denticon will continue to
                encourage original scientific research, promote academic
                excellence, and facilitate the exchange of innovative knowledge
                among dental professionals, researchers, academicians, and
                students. By providing meaningful exposure to emerging
                developments and evidence-based practices, the journal can make
                a valuable contribution to the advancement of oral healthcare
                and dental education.
              </p>

              <p>
                I commend the editorial team, reviewers, authors, and the RUHS
                College of Dental Sciences for their continued efforts towards
                maintaining high standards of academic and scientific
                publishing. I wish <strong>National Research Denticon</strong>{" "}
                continued growth, wider recognition, and greater academic impact
                in the years ahead.
              </p>

              <p style={{ fontWeight: "bold", marginTop: 28 }}>
                With my best wishes for its continued success.
              </p>

              <div style={{ marginTop: 30, lineHeight: 1.6 }}>
                <strong>Prof. (Dr.) Pramod Yeole</strong>
                <br />
                Vice-Chancellor
                <br />
                Rajasthan University of Health Sciences, Jaipur
              </div>
            </div>

            {/* Bottom Close Button */}
            <div style={{ textAlign: "center", marginTop: 32 }}>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowVcMessage(false)}
                style={{
                  background: "#003366",
                  border: "none",
                  borderRadius: "50px",
                  padding: "10px 30px",
                  fontWeight: 600,
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <NRDRUHSFooter />

      <div
        className="row"
        style={{ height: 60, margin: 0, background: "black" }}
      >
        <p
          className="copyright"
          style={{
            fontSize: 15,
            color: "#999",
            textAlign: "center",
            paddingTop: 18,
          }}
        >
          Copyrights © NRD RUHS Jaipur
        </p>
      </div>

      {/* Scroll to Top Button */}
      <button
        className={`scroll-to-top-btn ${scrolling ? "show" : ""}`}
        onClick={handleScrollToTop}
        title="Scroll to Top"
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </div>
  );
}

export default Home;
